import React from "react";
import { useNavigate } from "react-router-dom";
import { doc, updateDoc, increment } from "firebase/firestore";
import { db } from "../../firebase";
import "./FoodCard.css";

const FoodCard = ({ food }) => {
  const navigate = useNavigate();

  const handleCardClick = async () => {
    try {
      const foodRef = doc(db, "foods", food.id);
      await updateDoc(foodRef, {
        clicks: increment(1), // 클릭 수 증가
      });
      navigate(`/food/${food.id}`); // 상세 페이지로 이동
    } catch (error) {
      console.error("Error updating clicks:", error);
      // 클릭 수 업데이트 실패 시에도 이동하도록 설정
      navigate(`/food/${food.id}`);
    }
  };

  return (
    <div className="food-card" onClick={handleCardClick}>
      <h3>{food.name}</h3>
      <p>속편한 점수: {food.avgScore || "미평가"}</p>
    </div>
  );
};

export default FoodCard;